<template>
  <div class="row">
    <div class="col-sm-2">
      <OverviewBox title="Price List Template" avatarImage="/glass/img/pricing-ledger.png" :avatarCircleMode="false" :loading="loading">
        <div v-if="priceListTemplateLoaded">
          <h4>{{priceListTemplate.name}}</h4>

          <template v-if="priceListTemplate.labelList && priceListTemplate.labelList.length > 0">
            <h5>Labels</h5>
            <p>
              <span class="label label-empty label-overview-box mr-1" v-for="label in priceListTemplate.labelList" :key="label.id"><i class="fas fa-circle pr-1" :style="{color: label.colour}"> </i> {{label.name}}</span>
            </p>
          </template>
          
          <OverviewBoxList>
            <OverviewBoxListItem title="Active">
              <IconBoolean :value="priceListTemplate.isActive" />
            </OverviewBoxListItem>
            <OverviewBoxListItem title="Last Updated">{{formatDate(priceListTemplate.updatedAt)}}</OverviewBoxListItem>
            <OverviewBoxListItem title="Created At">{{formatDate(priceListTemplate.createdAt)}}</OverviewBoxListItem>
          </OverviewBoxList>
        </div>
      </OverviewBox>

      <OverviewActionBox v-if="userHasUpdatePermission(PermissionTypes.PricingPermissionTypes.priceListTemplate) && !editing">
        <OverviewActionButton class="btn-default" @click="editTemplateDetailsClicked" icon="fa-pencil">Edit Details</OverviewActionButton>
        <OverviewActionButton class="btn-default" @click="editTemplateClicked" icon="fa-pencil">Edit Template</OverviewActionButton>

        <OverviewActionDivider />
        <OverviewActionButton class="btn-danger" @click="deleteTemplateClicked" icon="fa-trash-alt">Delete Template</OverviewActionButton>
      </OverviewActionBox>

      <ContentBox title="Editing" v-if="editing">
        <template v-slot:content>
          <div class="row">
            <div class="col-md-12">
              <FormButton type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="submitChanges()" :loading="submitting" >Submit Changes</FormButton>
              <FormButton type="button" class="btn btn-default btn-sm btn-block" @click.prevent="cancelEditing()">Cancel Editing</FormButton>
            </div>
          </div>
        </template>
      </ContentBox>
    </div>

    <div class="col-sm-10">
      <PriceListTemplateEditor
        ref="priceListTemplateEditor"
        v-if="priceListTemplateLoaded"
        :editing="editing"
        :isNewTemplate="false"
        :priceListTemplateId="priceListTemplate.id"
        @priceGroupOverrideSettingsUpdated="priceListTemplate.priceGroupOverrideSettings = $event"
      />
    </div>
  </div>
</template>


<script>
import PriceListTemplateEditor from '@/modules/pricing/components/priceListTemplateEditor.vue'
import PriceListTemplateEditDialog from '@/modules/pricing/views/priceListTemplateEditDialog.vue'

export default {
  name: 'PriceListTemplate',
  components: {
    PriceListTemplateEditor
  },
  data: () => {
    return {
      loading: false,
      editing: false,
      submitting: false,
      priceListTemplate: null
    }
  },
  computed: {
    priceListTemplateLoaded() {
      return this.priceListTemplate && this.priceListTemplate.id
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true

      this.$apiService.pricingService.getPriceListTemplate(this.$route.params.id)
        .then((response) => {
          this.priceListTemplate = response.data
        })
        .catch(error => {
          this.displayNetworkError(error)
          
        })
        .finally(() => {
          this.loading = false
        })
    },
    reloadData() {
      this.requestData()

      if(this.$refs.priceListTemplateEditor) {
        this.$refs.priceListTemplateEditor.reloadData()
      }
    },
    editTemplateDetailsClicked() {
      this.displayModal(PriceListTemplateEditDialog, { 
        priceListTemplateId: parseInt(this.$route.params.id)
      })
      .then((success) => {
        if(success) {
          this.successToast('Price List Template Updated')
          this.reloadData()
        }
      })
    },
    editTemplateClicked() {
      this.editing = true
    },
    deleteTemplateClicked() {
      this.confirmDeleteMessage('Delete Price List Template', 'Are you sure you want to delete this price list template? This action cannot be undone.')
        .then(confirm => {
          if(confirm) {
            this.$apiService.pricingService.deletePriceListTemplate(this.priceListTemplate.id)
            .then(() => {            
              this.successToast('Price List Template Deleted')
              this.$router.push({ path: '/pricing/pricelisttemplates' })
            })
            .catch(error => {
              this.displayNetworkError(error)
            })
          }
        })
    },
    submitChanges() {
      this.submitting = true

      // Build the data
      this.priceListTemplate.priceTemplateData = this.$refs.priceListTemplateEditor.buildServerPriceListUpdateListData()

      this.$apiService.pricingService.updatePriceListTemplate(this.priceListTemplate.id, this.priceListTemplate)
      .then(response => {
        this.successToast('Price List Template Updated')
        this.editing = false
        this.reloadData()
      })
      .catch(err => {
        this.displayNetworkError(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    cancelEditing() {
      this.editing = false
      this.reloadData()
    }
  }
}
</script>